import { render } from "./IssuetrackerEditor.vue?vue&type=template&id=6d9ad102"
import script from "./IssuetrackerEditor.vue?vue&type=script&lang=js"
export * from "./IssuetrackerEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__